import produce from 'immer';
import { LIVE_CLASSROOM_CONTENT_GET, LIVE_CLASSROOM_COMMENTS_GET } from '../actions/liveclassroom';

const initialState = {
  selected_classroom: {},
  comments: [],
  contentNotAvailable: false
};

const liveClassroomReducer = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case LIVE_CLASSROOM_CONTENT_GET._SUCCESS: {
      const { response } = action;
      draft.selected_classroom = response;
      break;
    }
    case LIVE_CLASSROOM_CONTENT_GET._REQUEST: {
      draft.contentNotAvailable = false;
      break;
    }
    case LIVE_CLASSROOM_CONTENT_GET._ERROR: {
      draft.contentNotAvailable = false;
      break;
    }
    case LIVE_CLASSROOM_COMMENTS_GET._SUCCESS: {
      const { comments } = action;
      draft.comments = comments;
      break;
    }
    default:
      return state;
  }
  return draft;
});

export default liveClassroomReducer;